module.exports = __webpack_public_path__ + "static/media/AB_ZW10_11.a2c992e5.jpg";